import { Mic, Loader2, Search, X, Sparkles } from "lucide-react";

export default function SearchBar({
  value,
  onChange,
  onSubmit,
  onReset,
  hasSearched,
  recording,
  transcribing,
  thinking,
  onToggleRecording,
  inputRef,
  placeholder,
  submitLabel,
}) {
  const resolvedPlaceholder = placeholder ?? (hasSearched ? "Affine ta recherche…" : "Décris ce que tu recherches…");
  const resolvedSubmitLabel = submitLabel ?? (hasSearched ? "Affiner" : "Chercher");

  return (
    <div className="flex items-center gap-2 bg-gray-800 border border-gray-700 rounded-xl px-3 py-2.5">
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") onSubmit(); }}
        placeholder={resolvedPlaceholder}
        className="flex-1 text-sm text-white bg-transparent outline-none placeholder:text-gray-500"
        disabled={thinking || transcribing}
      />

      {/* Micro */}
      <button
        onClick={onToggleRecording}
        disabled={thinking || transcribing}
        title={recording ? "Arrêter l'enregistrement" : "Enregistrement vocal"}
        className={`w-8 h-8 rounded-lg flex items-center justify-center transition shrink-0 ${
          recording ? "bg-red-500 text-white" : "text-gray-400 hover:text-gray-200"
        } disabled:opacity-40`}
      >
        {transcribing ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mic className="w-4 h-4" />}
      </button>

      {/* Chercher / Affiner */}
      <button
        onClick={onSubmit}
        disabled={!value.trim() || thinking || transcribing}
        className="h-8 px-3 rounded-lg bg-teal-500 text-white text-xs font-semibold flex items-center gap-1.5 disabled:opacity-40 hover:bg-teal-400 transition shrink-0"
      >
        {hasSearched ? <Sparkles className="w-3.5 h-3.5" /> : <Search className="w-3.5 h-3.5" />}
        {resolvedSubmitLabel}
      </button>

      {/* Nouvelle recherche */}
      {hasSearched && (
        <button
          onClick={onReset}
          title="Nouvelle recherche"
          className="h-8 px-3 border border-gray-700 rounded-lg text-white text-xs flex items-center gap-1.5 disabled:opacity-40 hover:bg-teal-700 transition shrink-0"
        >
          Nouvelle recherche
        </button>
      )}
    </div>
  );
}
